import './home.scss';

import Hero from "./hero/hero";
import Cheetah from "./cheetah/cheetah";
import Diet from './diet/diet';
import Habitat from './habitat/habitat';
import Behavior from './behavior/behavior';
import LifeCycle from './lifecycle/lifecycle';
import Facts from './facts/facts';

export default function Home() {
    return (
        <section id="Home">
            <Hero/>
            <Cheetah/>
            <Diet/>
            <Habitat/>
            <Behavior/>
            <LifeCycle/>
            <Facts/>
        </section>
    );
};